<template>
  <div>
    <ListView
      ref="listView"
      :isFluid="true"
      title="車牌管理系统"
      @reload="reload"
      @create="actionCreate"
      :search.sync="search"
      :data="data"
      :page.sync="page"
      :header="header"
      :enableCreate="true"
      :search-box-placeholder="placeholder"
      :itemClass="getRowClass"
      :dense="true"
    >
      <template v-slot:btn>
        <v-btn color="primary" outlined @click="openForSaleVehicleList">
          <v-icon left>mdi-open-in-new</v-icon>
          幸運車牌出售
        </v-btn>
      </template>
      <!-- Custom Search Box -->
      <template v-slot:searchBox>
        <span></span>
      </template>

      <!-- Filter Section -->
      <template v-slot:filter>
        <v-row dense class="filter-row">
          <v-col cols="auto">
            <v-select
              v-model="pendingSearchField"
              :items="searchFieldOptions"
              dense
              outlined
              hide-details
              label="搜尋欄位"
            />
          </v-col>
          <v-col cols="auto">
            <v-text-field
              v-model="pendingSearchVal"
              dense
              outlined
              hide-details
              :placeholder="searchFieldLabel"
              prepend-inner-icon="mdi-magnify"
              clearable
              @keyup.enter="applyFilters"
            />
          </v-col>
          <v-col cols="auto">
            <v-menu
              ref="inputDateStartMenu"
              v-model="inputDateStartMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="pendingFilters.inputDateStart"
                  label="發出日期 開始"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  dense
                  outlined
                  hide-details
                  clearable
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="pendingFilters.inputDateStart"
                @input="inputDateStartMenu = false"
                no-title
                scrollable
              />
            </v-menu>
          </v-col>
          <v-col cols="auto">
            <v-menu
              ref="inputDateEndMenu"
              v-model="inputDateEndMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="pendingFilters.inputDateEnd"
                  label="發出日期 截止"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  dense
                  outlined
                  hide-details
                  clearable
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="pendingFilters.inputDateEnd"
                @input="inputDateEndMenu = false"
                no-title
                scrollable
              />
            </v-menu>
          </v-col>
          <v-col cols="auto">
            <v-select
              v-model="pendingFilters.filetype"
              :items="fileTypeOptions"
              dense
              outlined
              hide-details
              label="文件類別"
              clearable
            />
          </v-col>
          <v-col cols="auto">
            <v-menu
              ref="outDateStartMenu"
              v-model="outDateStartMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="pendingFilters.outDateStart"
                  label="到期日 開始"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  dense
                  outlined
                  hide-details
                  clearable
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="pendingFilters.outDateStart"
                @input="outDateStartMenu = false"
                no-title
                scrollable
              />
            </v-menu>
          </v-col>
          <v-col cols="auto">
            <v-menu
              ref="outDateEndMenu"
              v-model="outDateEndMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="pendingFilters.outDateEnd"
                  label="到期日 截止"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  dense
                  outlined
                  hide-details
                  clearable
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="pendingFilters.outDateEnd"
                @input="outDateEndMenu = false"
                no-title
                scrollable
              />
            </v-menu>
          </v-col>
          <v-col cols="auto">
            <v-select
              v-model="pendingFilters.state"
              :items="stateOptions"
              dense
              outlined
              hide-details
              label="車牌狀態"
              clearable
              item-text="text"
              item-value="value"
            />
          </v-col>
          <v-col cols="auto">
            <v-select
              v-model="pendingSortBy"
              :items="sortOptions"
              dense
              outlined
              hide-details
              label="排序顯示"
            />
          </v-col>
          <v-col cols="auto" class="d-flex align-center gap-2">
            <v-btn color="primary" @click="applyFilters" :loading="isLoading" :disabled="isLoading">
              <v-icon left>mdi-magnify</v-icon>
              搜尋
            </v-btn>
            <v-btn color="default" @click="resetFilters" :disabled="isLoading">
              <v-icon left>mdi-refresh</v-icon>
              清除選項
            </v-btn>
            <v-btn color="default" @click="handlePrint" :disabled="isLoading">
              <v-icon left>mdi-printer</v-icon>
              列印
            </v-btn>
          </v-col>
        </v-row>
      </template>

      <template v-slot:item.inputDate="{ item }">
        <span v-if="item.inputDate">{{ item.inputDate | moment('YYYY-MM-DD') }}</span>
        <span v-else></span>
      </template>
      <template v-slot:item.outDate="{ item }">
        <span v-if="item.outDate">{{ item.outDate | moment('YYYY-MM-DD') }}</span>
        <span v-else></span>
      </template>
      <template v-slot:item.phone="{ item }">
        <!-- <a
          v-if="item.phone"
          :href="generateWhatsAppUrl(item)"
          target="_blank"
          class="clickable-link"
          @click.stop
        >
          {{ item.phone }}
        </a> -->
        <span v-if="item.phone">
          {{ item.phone }}
        </span>
        <span v-else></span>
      </template>
      <template v-slot:item.stateLabel="{ item }">
        {{ item.state | translateOptions(stateOptions, 'value', 'text') }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn icon small color="primary" @click.stop="actionDetails(item)">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
        <v-btn v-if="false" icon small color="success" @click.stop="actionDuplicate(item)">
          <v-icon small>mdi-plus-circle-outline</v-icon>
        </v-btn>
        <v-btn icon small color="info" @click.stop="actionPrint(item)">
          <v-icon small>mdi-printer</v-icon>
        </v-btn>
      </template>
    </ListView>

    <LPMSDetailsDialog
      v-model="editDialog"
      :id="editId"
      :initial-data="initialData"
      @saved="handleSaved"
      @deleted="handleDeleted"
    />
  </div>
</template>

<script>
import { RESTFUL, lpmsState } from '@/data/constants';
import listViewPageMixin from '@/services/listViewPageMixin';
import { mapGetters } from 'vuex';
import LPMSDetailsDialog from '@/components/LPMS/LPMSDetailsDialog';
import { lpmsFileTypeOptions, lpmsStateOptions } from '@/data/optionsConstants';
import dayjs from 'dayjs';
import api from '@/api';
import { crudRead } from '@/api/crud';
import { printLPMS } from '@/services/utils';

export default {
  name: 'LPMS',
  props: {},
  components: {
    LPMSDetailsDialog,
  },
  data() {
    return {
      limit: 100,
      populate: '',
      editDialog: false,
      editId: 'new',
      initialData: null,
      // Filter data
      searchField: 'customer',
      pendingSearchField: 'customer',
      pendingSearchVal: '',
      searchFieldOptions: [
        { text: '客戶名稱', value: 'customer' },
        { text: '客戶電話', value: 'phone' },
        { text: '車牌號碼', value: 'vehno' },
        { text: '編號', value: 'businessno' },
      ],
      filters: {
        inputDateStart: null,
        inputDateEnd: null,
        outDateStart: null,
        outDateEnd: null,
        filetype: null,
        state: null,
      },
      pendingFilters: {
        inputDateStart: null,
        inputDateEnd: null,
        outDateStart: null,
        outDateEnd: null,
        filetype: null,
        state: null,
      },
      inputDateStartMenu: false,
      inputDateEndMenu: false,
      outDateStartMenu: false,
      outDateEndMenu: false,
      sortBy: 'inputDate_desc',
      pendingSortBy: 'inputDate_desc',
      sort: { inputDate: -1 },
      sortOptions: [
        { text: '按發出日期排序（默認） ↓', value: 'inputDate_desc' },
        { text: '按發出日期排序 ↑', value: 'inputDate_asc' },
        { text: '按到期日排序 ↓', value: 'outDate_desc' },
        { text: '按到期日排序 ↑', value: 'outDate_asc' },
        { text: '按數據ID排序 ↓', value: '_id_desc' },
        { text: '按數據ID排序 ↑', value: '_id_asc' },
      ],
      fileTypeOptions: lpmsFileTypeOptions,
      stateOptions: lpmsStateOptions,

      //print
      isPrinting: false,
    };
  },
  mixins: [listViewPageMixin],
  async mounted() {
    // Set initial sort
    this.updateSort();
  },
  computed: {
    ...mapGetters('auth', ['role', 'isMaster']),
    restfulURL() {
      return RESTFUL.lpms.list;
    },
    placeholder() {
      return '搜尋客戶 / 電話 / 車牌號碼 / 編號';
    },
    searchFieldLabel() {
      const field = this.searchFieldOptions.find(f => f.value === this.pendingSearchField);
      return field ? `請輸入${field.text}` : '請輸入搜尋內容';
    },
    searchPaths() {
      // Return the applied search field as search path
      return this.searchField ? [this.searchField] : undefined;
    },
    header() {
      return [
        { text: '發出日期/牌費到期日', value: 'inputDate' },
        { text: '文件類別', value: 'filetype' },
        { text: '車牌號碼', value: 'vehno' },
        { text: '客戶名稱', value: 'customer' },
        { text: '客戶電話', value: 'phone' },
        { text: '到期日', value: 'outDate' },
        { text: '狀態', value: 'stateLabel' },
        { text: '編號', value: 'businessno' },
        ...(this.isPrinting
          ? []
          : [
              {
                text: '操作',
                value: 'actions',
                sortable: false,
              },
            ]),
      ];
    },
    filter() {
      const filter = {};

      // Input date range filter
      if (this.filters.inputDateStart || this.filters.inputDateEnd) {
        filter.inputDate = {};
        if (this.filters.inputDateStart) {
          filter.inputDate.$gte = dayjs(this.filters.inputDateStart).startOf('day').toDate();
        }
        if (this.filters.inputDateEnd) {
          filter.inputDate.$lte = dayjs(this.filters.inputDateEnd).endOf('day').toDate();
        }
      }

      // Out date range filter
      if (this.filters.outDateStart || this.filters.outDateEnd) {
        filter.outDate = {};
        if (this.filters.outDateStart) {
          filter.outDate.$gte = dayjs(this.filters.outDateStart).startOf('day').toDate();
        }
        if (this.filters.outDateEnd) {
          filter.outDate.$lte = dayjs(this.filters.outDateEnd).endOf('day').toDate();
        }
      }

      // File type filter
      if (this.filters.filetype) {
        filter.filetype = this.filters.filetype;
      }

      // State filter
      if (this.filters.state) {
        filter.state = this.filters.state;
      }

      return Object.keys(filter).length > 0 ? filter : null;
    },
  },
  methods: {
    openForSaleVehicleList() {
      const { href } = this.$router.resolve({ name: 'for-sale-vehicle-list' });
      window.open(href, '_blank');
    },
    async handlePrint() {
      // Call the ListView's print method
      if (this.$refs.listView) {
        this.isPrinting = true;
        await this.$nextTick();
        this.$refs.listView.handlePrint();

        this.isPrinting = false;
      }
    },
    updateSort() {
      // Update the sort data property based on sortBy selection
      if (this.sortBy === 'inputDate_asc') {
        this.sort = { inputDate: 1 };
      } else if (this.sortBy === 'inputDate_desc') {
        this.sort = { inputDate: -1 };
      } else if (this.sortBy === 'outDate_asc') {
        this.sort = { outDate: 1 };
      } else if (this.sortBy === 'outDate_desc') {
        this.sort = { outDate: -1 };
      } else if (this.sortBy === '_id_asc') {
        this.sort = { _id: 1 };
      } else if (this.sortBy === '_id_desc') {
        this.sort = { _id: -1 };
      } else {
        // Default: inputDate descending
        this.sort = { inputDate: -1 };
      }
    },
    applyFilters() {
      // Apply pending values to actual filter values
      this.searchField = this.pendingSearchField;
      this.search = this.pendingSearchVal || '';
      this.filters = { ...this.pendingFilters };
      this.sortBy = this.pendingSortBy;
      this.updateSort();

      this.debouncedSearch();
    },
    resetFilters() {
      // Reset only pending filters (not applied filters)
      this.pendingSearchField = 'customer';
      this.pendingSearchVal = '';
      this.pendingFilters = {
        inputDateStart: null,
        inputDateEnd: null,
        outDateStart: null,
        outDateEnd: null,
        filetype: null,
        state: null,
      };
      this.pendingSortBy = 'inputDate_desc';
    },

    actionCreate() {
      this.editId = 'new';
      this.initialData = null;
      this.editDialog = true;
    },
    actionDetails(item) {
      this.editId = item._id;
      this.initialData = null;
      this.editDialog = true;
    },
    async actionPrint(item) {
      try {
        // Fetch full LPMS data with all details
        const lpmsData = await crudRead(api, RESTFUL.lpms.read, item._id, {
          populates: [],
        });

        // Call the print function
        printLPMS(lpmsData);
      } catch (error) {
        console.error('Failed to load LPMS data for printing:', error);
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: '載入列印資料失敗',
          type: 'error',
          color: 'error',
        });
      }
    },
    handleSaved() {
      this.initialData = null;
      this.reload();
    },
    handleDeleted() {
      this.initialData = null;
      this.reload();
    },
    actionDuplicate(item) {
      // Prepare data for duplication with selected fields only
      // Fields: 車牌號碼 (vehno), 客戶 (customer), 電話 (phone), 文件類別 (filetype)
      this.editId = 'new';
      this.initialData = {
        vehno: item.vehno,
        customer: item.customer,
        phone: item.phone,
        filetype: item.filetype,
      };
      this.editDialog = true;
    },
    generateWhatsAppUrl(item) {
      if (!item.phone) return '#';

      // Format phone number - remove any spaces, dashes, or special characters
      let phoneNumber = item.phone.replace(/[\s\-()]/g, '');

      // Prepend 852 if not already present
      if (!phoneNumber.startsWith('852')) {
        phoneNumber = '852' + phoneNumber;
      }

      // Construct the simple message
      const message = '您好!';

      // URL encode the message
      const encodedMessage = encodeURIComponent(message);

      // Return the full WhatsApp URL
      return `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`;
    },
    getRowClass(item) {
      const today = dayjs().startOf('day');
      const outDate = item.outDate ? dayjs(item.outDate).startOf('day') : null;
      const tenDaysLater = today.add(10, 'days');

      // Status: "售出中",'託管','託管出售',
      const sellingStates = [lpmsState.selling, lpmsState.custodian, lpmsState.custodianSelling];
      if (sellingStates.includes(item.state) && outDate) {
        // Overdue: past expiry date
        if (outDate.valueOf() < today.valueOf()) {
          return 'red-row';
        }
        // Within 10 days before expiry
        if (outDate.valueOf() <= tenDaysLater.valueOf()) {
          return 'red-row';
        }
      }

      // Status: "辦理中" (under handling)
      if (item.state === lpmsState.underHandling) {
        return 'yellow-row';
      }

      // Status: "已續期" (renewed) or "放棄出售" (abandoned to sell) or "已售出" (sold)
      // These should be in normal black color (no special class)
      if (
        item.state === lpmsState.renewed ||
        item.state === lpmsState.abandonedToSell ||
        item.state === lpmsState.sold
      ) {
        return '';
      }

      // Default: no special styling
      return '';
    },
  },
};
</script>

<style scoped lang="scss">
@mixin colored-row($color) {
  color: $color !important;
  font-weight: bold !important;
  a {
    color: $color !important;
  }
}
::v-deep .red-row {
  @include colored-row(var(--lpms-row-red));
}
::v-deep .yellow-row {
  @include colored-row(var(--lpms-row-yellow));
}
</style>

<style lang="scss">
/* Ensure LPMS row colors appear in print preview as they do on screen */
@media print {
  .red-row {
    color: var(--lpms-row-red) !important;
    font-weight: bold !important;
  }
  .red-row a {
    color: var(--lpms-row-red) !important;
  }
  .yellow-row {
    color: var(--lpms-row-yellow) !important;
    font-weight: bold !important;
  }
  .yellow-row a {
    color: var(--lpms-row-yellow) !important;
  }
}
</style>
